// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sender-details_wrapper__ldXhg","item":"sender-details_item__ll5pk"};